export const updateQueryParameter = (
  name: string,
  value: string | readonly string[],
) => {
  if (typeof window === 'undefined') {
    return
  }
  const url = new URL(window.location.toString())
  if (value) {
    if (typeof value === 'string') {
      url.searchParams.set(name, value)
    } else {
      url.searchParams.delete(name)
      value.forEach(p => url.searchParams.append(name, p))
    }
  } else {
    url.searchParams.delete(name)
  }
  return history.replaceState(null, '', `${url.pathname}${url.search}`)
}

export const clearQueryParameters = (parameterNames: string[]) => {
  if (typeof window === 'undefined') {
    return
  }
  const url = new URL(window.location.toString())
  parameterNames.forEach(p => url.searchParams.delete(p))
  return history.replaceState(null, '', `${url.pathname}${url.search}`)
}

export const isExternal = (url?: string) =>
  url && url.includes('http') && !url.includes('measurlabs.com')
